'use client';

import React from 'react';

const Button = ({ 
  children, 
  onClick, 
  variant = 'primary', 
  size = 'md', 
  disabled = false,
  type = 'button',
  className = '',
  ...props
}) => {
  const variants = {
    primary: 'bg-button-1 text-button-2 hover:opacity-90 focus:ring-blue-500',
    secondary: 'bg-gray-200 text-black hover:bg-gray-300 focus:ring-gray-300'
  };

  const sizes = {
    sm: 'px-3 py-1 text-sm',
    md: 'px-4 py-2',
    lg: 'px-6 py-3 text-lg'
  };

  return (
    <button data-component-id="src/components/ui/Button.jsx:27:4" data-component-path="src/components/ui/Button.jsx" data-component-line="27" data-component-file="Button.jsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22type%22%3A%22%5Bvar%3Atype%5D%22%2C%22%5Bspread%5D%22%3A%22true%22%7D"
      type={type}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      className={`
        rounded-xl
        transition-all 
        duration-150 
        focus:outline-none 
        focus:ring-2 
        focus:ring-opacity-50
        font-roboto-serif
        font-medium
        ${variants[variant]} 
        ${sizes[size]} 
        ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} 
        ${className}
      `.trim().replace(/\s+/g, ' ')}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;